import useAuthenticatedQuery from "./useAuthenticatedQuery";
const useGetMyCertificates = (id) => {
  const {
    data: MyCertificates,
    isLoading,
    error,
    refetch: refetchMyCertificates,
  } = useAuthenticatedQuery(
    ["mycertificates"],
    `/api/v1/users/${id}/certificates`
  );

  if (error) {
    console.log("error:", error);
  }

  return { MyCertificates, refetchMyCertificates, isLoading, error };
};

export default useGetMyCertificates;
